// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"743a1c5a","970":"77eefe73"}[chunkId] + ".chunk.js";
};